export const DK_ENVS: Record<string, string> = {
  '1': 'dk',
  '4': 'gi',
  '6': 'gi1',
  '7': 'xc',
  '9': 'dk1',
  '11': 'dk2',
  '15': 'dk3',
  '17': 'hr0',
  '24': 'dk4',
  '25': 'dk5',
  '31': 'br0',
  '79': 'dk6',
  '80': 'dk7',
  '93': 'dk8',
  '94': 'dk9',
  '95': 'dk10',
  '113': 'dk11',
  '114': 'dk12',
  '116': 'dk13',
  '117': 'dk14',
  '129': 'dk15',
  '131': 'dk16',
  '132': 'dk17',
};

//
// regex Patterns
//
export const PROMO_NAME_PATTERN = /#\w+#(?:\d*)?(?:~\w+~)?|~\w+~/g;
export const PROMO_BRAND_PATTERN = /#([^#]+)#/;
export const PROMO_SUPPORTED_BEAUTIFIED_KEYS = ['totalPrizeAmountBeautified', 'highestPrizeBeautified'];

export const APIS = {
  FETCH_PROMOTIONS_INFO: '/api/v3/fetchPromotionsInfo',
  PROMO_OPT_INFO: '/api/promo/optInfo',
  FETCH_INSTANT_POINTS: '/api/v2/fetchinstantpoints',
  UPDATE_JWT_TOKEN: '/api/ui/updateJwtToken',
  LEADERBOARD: '/api/v2/leaderboard/',
  LEADERBOARD_AROUND_ME: '/api/v2/leaderboardAroudMe/',
  PRIZES_AND_WINNERS: '/api/v2/prizedrop/prizesAndwinners',
  FETCH_SCORE: '/api/v2/score',
  FETCH_ROUND_HISTORY: '/api/fetchRoundHistory',
  FETCH_ROUND_HISTORY_BY_WS: '/api/v2/fetchRoundHistoryByWS',
  PROMO_ACK: '/api/promo/ack',
  UPDATE_SCREEN_NAME: '/api/updateScreenName',
};
